import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { IndexListValueService } from '../../apiModule1';

export const indexListValueResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    service: IndexListValueService = inject(IndexListValueService)) => {
    return service.apiIndexlistvalueGet({}, 'body', false, { transferCache: false });
};
